import { environment } from "@environment/environment"

export const urlAuth = environment.apiService_Auth
export const urlErp = environment.apiService_Erp
export const urlReport = environment.apiService_Report
export const urlEcommerce = environment.apiService_Ecommerce